export enum QuestionType {
  Boolean = 1,
  Integer = 2,
  String = 3,
}
